import { useReducer } from "react"

const useToggle = (initial = false) =>
  useReducer((prev, next) => (next !== null && next !== void 0 ? next : !prev), initial)

export default useToggle
